import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useReveal } from "@/hooks/useReveal";

export default function ExpertiseSection() {
  const [areas, setAreas] = useState([]);
  const ref = useReveal();

  useEffect(() => {
    api.get("/departments").then((r) => setAreas(r.data)).catch(() => setAreas([]));
  }, []);

  return (
    <section className="py-28 md:py-40 reveal" ref={ref} data-testid="expertise-section">
      <div className="max-w-[1560px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-x-24 md:gap-y-16">
          <div className="md:col-span-4 md:sticky md:top-32 self-start">
            <h2 className="h-display text-[clamp(2rem,4.4vw,3.8rem)]">
              Six core departments.<br />
              <span className="text-[#1E3668]">One coherent firm.</span>
            </h2>
            <p className="mt-8 text-graphite/80 leading-relaxed max-w-md">
              Our departments are designed to work as one. Most mandates draw on two or more,
              and the firm is built to make that integration the norm.
            </p>
            <Link to="/expertise" className="link-grow mt-8 inline-flex text-sm font-medium tracking-[0.16em] uppercase" data-testid="expertise-view-all">
              View all services <ArrowUpRight size={16} className="arrow" />
            </Link>
          </div>

          <ul className="md:col-span-8 hairline-top" data-testid="expertise-list">
            {areas.map((a, i) => (
              <li key={a.slug} className="num-list-row hairline-bottom">
                <Link
                  to={`/expertise/${a.slug}`}
                  className="grid grid-cols-12 items-center gap-4 py-7 md:py-9"
                  data-testid={`expertise-row-${a.slug}`}
                >
                  <span className="col-span-2 md:col-span-1 overline text-graphite/55">{String(i + 1).padStart(2, "0")}</span>
                  <div className="col-span-7 md:col-span-8 min-w-0">
                    <span className="num-title block text-[clamp(1.3rem,2vw,1.9rem)] font-semibold tracking-tight leading-tight">{a.title}</span>
                  </div>
                  <span className="hidden md:flex col-span-2 text-sm text-graphite/55 self-center justify-end pr-4 whitespace-nowrap">
                    {(a.service_count ?? a.services_count) || 0} services
                  </span>
                  <span className="col-span-3 md:col-span-1 justify-self-end num-arrow">
                    <ArrowUpRight size={26} className="text-[#1E3668]" />
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
